export const DistrictWiseCountQuery = {
    "measures": [
        "master.total_count"
      ],
      "dimensions": [
        "master.state",
        "master.district",
        "master.status"
      ],
      "order": {
        "master.total_count": "desc"
      },
  }

  export const StateWiseCountQuery = {
    "measures": [
        "master.total_count"
      ],
      "dimensions": [
        "master.state",
        "master.status"    
      ],
      "order": {
        "master.total_count": "desc"
      },
  }


  export const ClientWiseStateQuery = {
    "dimensions": [
      "master.state",
      "master.district",
      "master.status",
      "master.client_name",
      "master.address"
    ],
    "order": {
      "master.state": "asc"
    },
    // "limit": 10000,
    // "offset": 0
  }



export const handleDistrictQueryFilters = (
  modalityCheck,
  email,
  accessLevel
) => {
  let filters = [];
  let tableName = "master";

  if (modalityCheck?.length>0) {
    filters.push({
      member: tableName + ".modality",
      operator: "contains",
      values: modalityCheck,
    });
  }

  if(email==='rajeshm@cancercentersofamerica.in'){
    filters.push({
      member: tableName + ".status",
      operator: "equals",
      values: ['POTENTIAL'],
    });
  }
  else if(accessLevel?.access!=='admin'){
    filters.push({
      member: tableName + ".state",
      operator: "contains",
      values: accessLevel?.state,
    });
  }

  if (filters?.length && modalityCheck?.length<=4) {
    return { ...DistrictWiseCountQuery, filters };
  }
  return DistrictWiseCountQuery;
};


export const handleQueryFilters = (
    modalityCheck,email,accessLevel
  ) => {
    let filters = [];
    let tableName = "master";
    
    if (modalityCheck?.length>0) {
      filters.push({
        member: tableName + ".modality",
        operator: "contains",
        values: modalityCheck,
      });
    }

    if(email==='rajeshm@cancercentersofamerica.in'){
      filters.push({
        member: tableName + ".status",
        operator: "equals",
        values: ['POTENTIAL'],
      });
    }
    else if(accessLevel?.access!=='admin'){
      filters.push({
        member: tableName + ".state",
        operator: "contains",
        values: accessLevel?.state,
      });
    }
  
    if (filters.length && modalityCheck.length<=4) {
      return { ...StateWiseCountQuery, filters };
    }
    return StateWiseCountQuery;
  };



 export const handleClientDataQueryModality=(
    modalityCheck,email,accessLevel
  ) => {
    let filters = [];
    let tableName = "master";

    if (modalityCheck?.length>0) {
      filters.push({
        member: tableName + ".modality",
        operator: "contains",
        values: modalityCheck,
      });
    }
    console?.log(accessLevel)
    if(email==='rajeshm@cancercentersofamerica.in'){
      filters.push({
        member: tableName + ".status",
        operator: "equals",
        values: ['POTENTIAL'],
      });
    }
    
    else if(accessLevel?.access!=='admin'){
     
      filters.push({
        member: tableName + ".state",
        operator: "contains",
        values: accessLevel?.state,
      });
    }
    console.log(filters)
    if (filters.length && modalityCheck.length<=4) {
      return { ...ClientWiseStateQuery, filters };
    }
    return ClientWiseStateQuery;
  };